export const getSplittedText = ({
  labelCount,
  allCount,
  category,
}: {
  labelCount: number;
  allCount: number;
  category?: string;
}) => {
  const targetCategory = category ?? '(분류 없음)';

  if (labelCount >= 2) {
    return `${targetCategory} 외 (${labelCount}/${allCount})`;
  }

  if (labelCount === 1) {
    return `${targetCategory} (${labelCount}/${allCount})`;
  }

  if (labelCount === 0) {
    return `${targetCategory} (${labelCount}/${allCount})`;
  }
};
